// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { BrowsePath, BrowsePathT } from "./browse-path";
import { ByteStringNodeId, ByteStringNodeIdT } from "./byte-string-node-id";
import { GuidNodeId, GuidNodeIdT } from "./guid-node-id";
import { NumericNodeId, NumericNodeIdT } from "./numeric-node-id";
import { StringNodeId, StringNodeIdT } from "./string-node-id";

/**
 * OPC UA node identifier: a concrete NodeId (numeric/string/guid/opaque) or a
 * browse path resolved at runtime.
 */
export enum NodeIdentifier {
  NONE = 0,
  NumericNodeId = 1,
  StringNodeId = 2,
  GuidNodeId = 3,
  ByteStringNodeId = 4,
  BrowsePath = 5,
}

export function unionToNodeIdentifier(
  type: NodeIdentifier,
  accessor: (
    obj: BrowsePath | ByteStringNodeId | GuidNodeId | NumericNodeId | StringNodeId,
  ) => BrowsePath | ByteStringNodeId | GuidNodeId | NumericNodeId | StringNodeId | null,
): BrowsePath | ByteStringNodeId | GuidNodeId | NumericNodeId | StringNodeId | null {
  switch (NodeIdentifier[type]) {
    case "NONE":
      return null;
    case "NumericNodeId":
      return accessor(new NumericNodeId())! as NumericNodeId;
    case "StringNodeId":
      return accessor(new StringNodeId())! as StringNodeId;
    case "GuidNodeId":
      return accessor(new GuidNodeId())! as GuidNodeId;
    case "ByteStringNodeId":
      return accessor(new ByteStringNodeId())! as ByteStringNodeId;
    case "BrowsePath":
      return accessor(new BrowsePath())! as BrowsePath;
    default:
      return null;
  }
}

export function unionListToNodeIdentifier(
  type: NodeIdentifier,
  accessor: (
    index: number,
    obj: BrowsePath | ByteStringNodeId | GuidNodeId | NumericNodeId | StringNodeId,
  ) => BrowsePath | ByteStringNodeId | GuidNodeId | NumericNodeId | StringNodeId | null,
  index: number,
): BrowsePath | ByteStringNodeId | GuidNodeId | NumericNodeId | StringNodeId | null {
  switch (NodeIdentifier[type]) {
    case "NONE":
      return null;
    case "NumericNodeId":
      return accessor(index, new NumericNodeId())! as NumericNodeId;
    case "StringNodeId":
      return accessor(index, new StringNodeId())! as StringNodeId;
    case "GuidNodeId":
      return accessor(index, new GuidNodeId())! as GuidNodeId;
    case "ByteStringNodeId":
      return accessor(index, new ByteStringNodeId())! as ByteStringNodeId;
    case "BrowsePath":
      return accessor(index, new BrowsePath())! as BrowsePath;
    default:
      return null;
  }
}

export type NodeIdentifierT =
  | { type: "NONE"; value: null }
  | { type: "NumericNodeId"; value: NumericNodeIdT }
  | { type: "StringNodeId"; value: StringNodeIdT }
  | { type: "GuidNodeId"; value: GuidNodeIdT }
  | { type: "ByteStringNodeId"; value: ByteStringNodeIdT }
  | { type: "BrowsePath"; value: BrowsePathT };
